var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card container flex-row py-1 mt-6",staticStyle:{"background-color":"#F6F6F6"}},[_c('h5',{staticClass:"col-xl-4 col-lg-12 mt-3"},[_vm._v("Chấm điểm "+_vm._s(_vm.currentTest?'Writing':'Speaking')+": "+_vm._s(this.$route.query.name ?? ""))])])
}
var staticRenderFns = []

export { render, staticRenderFns }